export enum FilterNamesEnum {
  SEARCH_BY_NAME = 'searchByName',
  PROGRAMS = 'programsFilter',
  GRADE_LEVELS = 'gradeLevelsFilter',
  YEARS = 'programYearsFilter',
  ORDER_BY = 'orderBy',
  ORDER_ASC = 'orderAsc',
}
